









import {Component, Vue} from 'vue-property-decorator';
import JdsSheet from "@/design-system/patterns/Sheet/JdsSheet.vue"

@Component({
    components: {JdsSheet}
})
export default class JdpCandidateProfile extends Vue {
}
